var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"productFeatures"},[_c('h2',[_vm._v("产品特性")]),_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"features"},[_c('h3',[_vm._v(_vm._s(item.title))]),_c('p',[_vm._v(_vm._s(item.intro))])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }